import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {EscolhaModalidadeGuard} from '../../interceptors/escolha-modalidade.guard';
import {EcgPorTerceirosPesquisaComponent} from './pesquisa/ecg-por-terceiros-pesquisa.component';
import {EcgPorTerceirosCadastroComponent} from './cadastro/ecg-por-terceiros-cadastro.component';
import {AuthenticationGuard} from '@bndes/bndes-ux4/bn-seguranca';

const routes: Routes = [
  {
    path: 'ecg-por-terceiros',
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    data: {canReuse: false},

    children: [
      {
        path: '',
        redirectTo: 'pesquisa',
        pathMatch: 'full'

      },
      {
        path: 'pesquisa',
        component: EcgPorTerceirosPesquisaComponent
      },
      {
        path: 'cadastro',
        component: EcgPorTerceirosCadastroComponent
      },
      {
        path: 'edicao/:id',
        component: EcgPorTerceirosCadastroComponent
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class EcgPorTerceirosRoutingModule {
}
